<template>
  <v-layout class="justify-center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline font-weight-black text-color-title">{{ title }}</v-card-title>
        <v-card-text> 
          <span class="font-weight-medium color-text-literals"><slot></slot></span> 
        </v-card-text>
        <v-card-actions>
          <v-layout class="row wrap">
            <v-flex>
              <div class="d-flex justify-between">
                <v-btn flat style="flex: 1" class="font-weight-black" @click="$emit('onCancel')">{{i18n('Cancelar')}}</v-btn>
                <v-btn flat style="flex: 1" class="font-weight-black btn-bg-color" @click="$emit('onConfirm')">{{i18n('Confirmar')}}</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'EnableUserModal',
    props: {
      dialog: { type: Boolean },
      title: { type: String },
      user: { type: Object }
    },
    methods: {
      i18n(str) {
        return this.$root.l(str)
      }
    }
  }
</script>

<style>
.btn-bg-color {
  background-color: var(--secondary-button-background-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/ConfirmModal.vue